/* tslint:disable */
/* eslint-disable */
/**
 * MHB2B Contract API specs
 * MHB2B Contract API specs for middleware and Frontend components. We agreed to cover create / update / delete usecases with generic service operations which are also capable to serve multiple future clients (e.g. browser & mobile) at the same time.
 *
 * The version of the OpenAPI document: 1.121.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 * Enumerated type of Account verification state that indicates if the company account is verified
 * @export
 * @enum {string}
 */
export const AccountVerificationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Describes a binary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const BinaryBooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR'
};
/**
 * Describes a binary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const BinaryFilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER'
};
/**
 * Describes a binary boolean operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const BooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR',
    Not: 'NOT'
};
/**
 * Enumerated type of business type for which is the company used for
 * @export
 * @enum {string}
 */
export const BusinessType = {
    Other: 'LOB_OTHER',
    Construction: 'LOB_CONSTRUCTION',
    Emergency: 'LOB_EMERGENCY',
    Logistic: 'LOB_LOGISTIC',
    Manufacturing: 'LOB_MANUFACTURING',
    PeopleMover: 'LOB_PEOPLE_MOVER',
    Rental: 'LOB_RENTAL',
    ServiceWorkshop: 'LOB_SERVICE_WORKSHOP',
    TradeEgrocery: 'LOB_TRADE_EGROCERY'
};
/**
 * Brand types of a credit card
 * @export
 * @enum {string}
 */
export const CardOnFileAuthenticationStatusType = {
    NoAuth: 'NoAuth',
    Auth: 'Auth',
    Auth3ds1: 'Auth3ds1',
    Auth3ds2: 'Auth3ds2'
};
/**
 * Enumerated type of Account business verification state that indicates if the company account is verified by business commercial registration
 * @export
 * @enum {string}
 */
export const CommercialRegistrationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Brand types of a credit card
 * @export
 * @enum {string}
 */
export const CreditCardBrandType = {
    Visa: 'visa',
    Mastercard: 'mastercard',
    Maestro: 'maestro',
    Jcb: 'jcb',
    Amex: 'amex',
    Diners: 'diners',
    Koreanlocal: 'koreanlocal',
    CarteBancaire: 'carte bancaire',
    Mir: 'mir',
    Rupay: 'rupay'
};
/**
 * Customer business type.
 * @export
 * @enum {string}
 */
export const CustomerBusinessType = {
    B2C: 'B2C',
    B2B: 'B2B'
};
export const CustomerTypeIdTypeEnum = {
    _1A: '1A',
    _2A: '2A',
    _2B: '2B',
    _2C: '2C',
    _3: '3'
};
/**
 * Enumerated type of a failure notification type
 * @export
 * @enum {string}
 */
export const FailureNotificationType = {
    Info: 'INFO',
    Warn: 'WARN',
    Error: 'ERROR'
};
/**
 * Enumerated type of field tooltip
 * @export
 * @enum {string}
 */
export const FieldTooltipType = {
    Info: 'INFO'
};
/**
 * Enumerated type of Field usage for which is the field inside company used for
 * @export
 * @enum {string}
 */
export const FieldUsageType = {
    Mandatory: 'MANDATORY',
    Optional: 'OPTIONAL',
    Undefined: 'UNDEFINED'
};
/**
 * Describes a filter operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const FilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER',
    IsNotNull: 'IS_NOT_NULL',
    IsNull: 'IS_NULL'
};
/**
 * Enumerated type of the supported filter types:   TEXT_SEARCH - allows to define an arbitrary (free-)text string   VALUE_LIST - allows to select one or more values from a pre-defined list of available values   DATE_RANGE - allows to specify an earliest/latest date (range) criteria   NUMERIC_RANGE - allows to specify a min/max numeric (range) criteria
 * @export
 * @enum {string}
 */
export const FilterOptionType = {
    TextSearch: 'TEXT_SEARCH',
    ValueList: 'VALUE_LIST',
    DateRange: 'DATE_RANGE',
    NumericRange: 'NUMERIC_RANGE'
};
/**
 * Enumerated type of the invitation state.
 * @export
 * @enum {string}
 */
export const InvitationState = {
    Undefined: 'UNDEFINED',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Pending: 'PENDING'
};
/**
 * Enumerated type of invoice address type
 * @export
 * @enum {string}
 */
export const InvoiceAddressType = {
    CompanyAddress: 'COMPANY_ADDRESS',
    CustomAddress: 'CUSTOM_ADDRESS'
};
/**
 *
 * @export
 * @enum {string}
 */
export const LengthType = {
    Kilometer: 'kilometer',
    Meter: 'meter',
    Centimeter: 'centimeter',
    Millimeter: 'millimeter',
    Foot: 'foot',
    Inch: 'inch',
    Yard: 'yard',
    Mile: 'mile'
};
/**
 * Enumerated type of the permission mode
 * @export
 * @enum {string}
 */
export const PermissionMode = {
    Grant: 'GRANT',
    Deny: 'DENY'
};
/**
 * Enumerated type of the state for preferred contacts. The state UNASSIGNED means that a contact is assignable but not yet persisted. The ASSIGNED contacts are already assigned to a company or vehicle.
 * @export
 * @enum {string}
 */
export const PreferredContactState = {
    Unassigned: 'UNASSIGNED',
    Assigned: 'ASSIGNED'
};
/**
 * type of a `RoleConditionGroup` that defines how to build the boolean concatenation of multiple nested `RoleConditionMappings`
 * @export
 * @enum {string}
 */
export const RoleConditionGroupType = {
    And: 'AND',
    Or: 'OR',
    Not: 'NOT'
};
/**
 * Sort order:   * `asc` - Ascending, from A to Z or 0-9   * `desc` - Descending, from Z to A or 0-9
 * @export
 * @enum {string}
 */
export const SortOperator = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 * Describes a unary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const UnaryBooleanOperator = {
    Not: 'NOT'
};
/**
 * Describes an unary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const UnaryFilterOperator = {
    NotNull: 'IS_NOT_NULL',
    Null: 'IS_NULL'
};
/**
 * Enumerated type of a vehicle authorization
 * @export
 * @enum {string}
 */
export const VehicleAuthorizationType = {
    Company: 'COMPANY',
    User: 'USER',
    UserChooser: 'USER_CHOOSER',
    Partner: 'PARTNER'
};
/**
 * Enumerated type of a notification category
 * @export
 * @enum {string}
 */
export const VehicleNotificationCategory = {
    UrgentAction: 'URGENT_ACTION',
    RetailAction: 'RETAIL_ACTION',
    FleetAction: 'FLEET_ACTION',
    PairingRequest: 'PAIRING_REQUEST',
    UnverifiedVehicle: 'UNVERIFIED_VEHICLE',
    ServiceA: 'SERVICE_A',
    ServiceB: 'SERVICE_B',
    GeneralInspection: 'GENERAL_INSPECTION'
};
/**
 * Enumerated type of a notification status
 * @export
 * @enum {string}
 */
export const VehicleNotificationStatus = {
    Reopened: 'REOPENED',
    New: 'NEW',
    Created: 'CREATED',
    InProgress: 'IN_PROGRESS',
    Sent: 'SENT',
    Delegated: 'DELEGATED'
};
/**
 * Options which define the input state of VehicleSalesDiscountScheme
 * @export
 * @enum {string}
 */
export const VehicleSalesDiscountSchemeOptionType = {
    None: 'NONE',
    NationalDiscountCode: 'NATIONAL_DISCOUNT_CODE',
    FleetSize: 'FLEET_SIZE',
    FleetSizeCount: 'FLEET_SIZE_COUNT',
    PurchaseCooperative: 'PURCHASE_COOPERATIVE',
    UniqueCustomerId: 'UNIQUE_CUSTOMER_ID'
};
/**
 * Enumerated type of vehicle sales discount scheme usage
 * @export
 * @enum {string}
 */
export const VehicleSalesDiscountSchemeType = {
    NoDiscount: 'NO_DISCOUNT',
    DiscountIdSpecified: 'DISCOUNT_ID_SPECIFIED',
    FleetSizeSpecified: 'FLEET_SIZE_SPECIFIED',
    FleetSizeCountSpecified: 'FLEET_SIZE_COUNT_SPECIFIED',
    PurchaseCooperativeSpecified: 'PURCHASE_COOPERATIVE_SPECIFIED',
    DiscountNotUsed: 'DISCOUNT_NOT_USED'
};
/**
 * Enumerated type of a vehicle type. See mapping logic https://git.daimler.com/dh-io-mmcs/commons-be/blob/master/mmc_connector_client/src/main/java/com/daimler/mymercedes/mmc/backend/connectors/datacontext/VehicleInfoDC.java
 * @export
 * @enum {string}
 */
export const VehicleTypeType = {
    ConnectVehicle: 'CONNECT_VEHICLE',
    HybridVehicle: 'HYBRID_VEHICLE',
    AdapterVehicle: 'ADAPTER_VEHICLE',
    None: 'NONE'
};
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
export const CompaniesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {CompanyCUDRequest} companyCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeleteCompanies: (companyCUDRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyCUDRequest' is not null or undefined
            assertParamExists('createUpdateDeleteCompanies', 'companyCUDRequest', companyCUDRequest);
            const localVarPath = `/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyCUDRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {ViewCompanyCUDRequest} viewCompanyCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeleteViewCompanies: (viewCompanyCUDRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'viewCompanyCUDRequest' is not null or undefined
            assertParamExists('createUpdateDeleteViewCompanies', 'viewCompanyCUDRequest', viewCompanyCUDRequest);
            const localVarPath = `/view-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(viewCompanyCUDRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of companies
         * @param {CompanyDataBatchRequest} companyDataBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies: (companyDataBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'companyDataBatchRequest' is not null or undefined
            assertParamExists('getCompanies', 'companyDataBatchRequest', companyDataBatchRequest);
            const localVarPath = `/companies-fsp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyDataBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get company request via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId with a nested meId property in the message body
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCompany: (company, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'company' is not null or undefined
            assertParamExists('getCompany', 'company', company);
            const localVarPath = `/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(company, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of view companies
         * @param {ViewCompanyFSPBatchRequest} viewCompanyFSPBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewCompanies: (viewCompanyFSPBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'viewCompanyFSPBatchRequest' is not null or undefined
            assertParamExists('getViewCompanies', 'viewCompanyFSPBatchRequest', viewCompanyFSPBatchRequest);
            const localVarPath = `/view-companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(viewCompanyFSPBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CompaniesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {CompanyCUDRequest} companyCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeleteCompanies(companyCUDRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUpdateDeleteCompanies(companyCUDRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {ViewCompanyCUDRequest} viewCompanyCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeleteViewCompanies(viewCompanyCUDRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUpdateDeleteViewCompanies(viewCompanyCUDRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of companies
         * @param {CompanyDataBatchRequest} companyDataBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(companyDataBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompanies(companyDataBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get company request via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId with a nested meId property in the message body
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCompany(company, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCompany(company, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of view companies
         * @param {ViewCompanyFSPBatchRequest} viewCompanyFSPBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewCompanies(viewCompanyFSPBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getViewCompanies(viewCompanyFSPBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CompaniesApiFp(configuration);
    return {
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {CompanyCUDRequest} companyCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeleteCompanies(companyCUDRequest, options) {
            return localVarFp.createUpdateDeleteCompanies(companyCUDRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {ViewCompanyCUDRequest} viewCompanyCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeleteViewCompanies(viewCompanyCUDRequest, options) {
            return localVarFp.createUpdateDeleteViewCompanies(viewCompanyCUDRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of companies
         * @param {CompanyDataBatchRequest} companyDataBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanies(companyDataBatchRequest, options) {
            return localVarFp.getCompanies(companyDataBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get company request via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId with a nested meId property in the message body
         * @param {Company} company
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCompany(company, options) {
            return localVarFp.getCompany(company, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of view companies
         * @param {ViewCompanyFSPBatchRequest} viewCompanyFSPBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getViewCompanies(viewCompanyFSPBatchRequest, options) {
            return localVarFp.getViewCompanies(viewCompanyFSPBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
    /**
     *
     * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
     * @param {CompanyCUDRequest} companyCUDRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    createUpdateDeleteCompanies(companyCUDRequest, options) {
        return CompaniesApiFp(this.configuration).createUpdateDeleteCompanies(companyCUDRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
     * @param {ViewCompanyCUDRequest} viewCompanyCUDRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    createUpdateDeleteViewCompanies(viewCompanyCUDRequest, options) {
        return CompaniesApiFp(this.configuration).createUpdateDeleteViewCompanies(viewCompanyCUDRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Implements the FSP pattern to flexibly query for a list of companies
     * @param {CompanyDataBatchRequest} companyDataBatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    getCompanies(companyDataBatchRequest, options) {
        return CompaniesApiFp(this.configuration).getCompanies(companyDataBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get company request via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId with a nested meId property in the message body
     * @param {Company} company
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    getCompany(company, options) {
        return CompaniesApiFp(this.configuration).getCompany(company, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Implements the FSP pattern to flexibly query for a list of view companies
     * @param {ViewCompanyFSPBatchRequest} viewCompanyFSPBatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    getViewCompanies(viewCompanyFSPBatchRequest, options) {
        return CompaniesApiFp(this.configuration).getViewCompanies(viewCompanyFSPBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * PreferredContactsApi - axios parameter creator
 * @export
 */
export const PreferredContactsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {PreferredContactCUDRequest} preferredContactCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeletePreferredContacts: (preferredContactCUDRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'preferredContactCUDRequest' is not null or undefined
            assertParamExists('createUpdateDeletePreferredContacts', 'preferredContactCUDRequest', preferredContactCUDRequest);
            const localVarPath = `/preferred-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(preferredContactCUDRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of preferred contacts
         * @param {PreferredContactBatchRequest} preferredContactBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredContacts: (preferredContactBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'preferredContactBatchRequest' is not null or undefined
            assertParamExists('getPreferredContacts', 'preferredContactBatchRequest', preferredContactBatchRequest);
            const localVarPath = `/preferred-contacts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(preferredContactBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * PreferredContactsApi - functional programming interface
 * @export
 */
export const PreferredContactsApiFp = function (configuration) {
    const localVarAxiosParamCreator = PreferredContactsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {PreferredContactCUDRequest} preferredContactCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeletePreferredContacts(preferredContactCUDRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUpdateDeletePreferredContacts(preferredContactCUDRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of preferred contacts
         * @param {PreferredContactBatchRequest} preferredContactBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredContacts(preferredContactBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPreferredContacts(preferredContactBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * PreferredContactsApi - factory interface
 * @export
 */
export const PreferredContactsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PreferredContactsApiFp(configuration);
    return {
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {PreferredContactCUDRequest} preferredContactCUDRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUpdateDeletePreferredContacts(preferredContactCUDRequest, options) {
            return localVarFp.createUpdateDeletePreferredContacts(preferredContactCUDRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Implements the FSP pattern to flexibly query for a list of preferred contacts
         * @param {PreferredContactBatchRequest} preferredContactBatchRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreferredContacts(preferredContactBatchRequest, options) {
            return localVarFp.getPreferredContacts(preferredContactBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PreferredContactsApi - object-oriented interface
 * @export
 * @class PreferredContactsApi
 * @extends {BaseAPI}
 */
export class PreferredContactsApi extends BaseAPI {
    /**
     *
     * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
     * @param {PreferredContactCUDRequest} preferredContactCUDRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferredContactsApi
     */
    createUpdateDeletePreferredContacts(preferredContactCUDRequest, options) {
        return PreferredContactsApiFp(this.configuration).createUpdateDeletePreferredContacts(preferredContactCUDRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Implements the FSP pattern to flexibly query for a list of preferred contacts
     * @param {PreferredContactBatchRequest} preferredContactBatchRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreferredContactsApi
     */
    getPreferredContacts(preferredContactBatchRequest, options) {
        return PreferredContactsApiFp(this.configuration).getPreferredContacts(preferredContactBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProfileOverviewApi - axios parameter creator
 * @export
 */
export const ProfileOverviewApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get profile-overview via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId/UserId with a nested meId property in the message body
         * @param {number} [userProfileImageSize] A positive integer which describes the maximum edge length of the returned picture. The UPP will scale the picture to fit this size
         * @param {CompanyFSPBatchRequest} [companyFSPBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileOverview: (userProfileImageSize, companyFSPBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profile-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (userProfileImageSize !== undefined) {
                localVarQueryParameter['userProfileImageSize'] = userProfileImageSize;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(companyFSPBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProfileOverviewApi - functional programming interface
 * @export
 */
export const ProfileOverviewApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProfileOverviewApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get profile-overview via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId/UserId with a nested meId property in the message body
         * @param {number} [userProfileImageSize] A positive integer which describes the maximum edge length of the returned picture. The UPP will scale the picture to fit this size
         * @param {CompanyFSPBatchRequest} [companyFSPBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileOverview(userProfileImageSize, companyFSPBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProfileOverview(userProfileImageSize, companyFSPBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProfileOverviewApi - factory interface
 * @export
 */
export const ProfileOverviewApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProfileOverviewApiFp(configuration);
    return {
        /**
         *
         * @summary Get profile-overview via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId/UserId with a nested meId property in the message body
         * @param {number} [userProfileImageSize] A positive integer which describes the maximum edge length of the returned picture. The UPP will scale the picture to fit this size
         * @param {CompanyFSPBatchRequest} [companyFSPBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileOverview(userProfileImageSize, companyFSPBatchRequest, options) {
            return localVarFp.getProfileOverview(userProfileImageSize, companyFSPBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProfileOverviewApi - object-oriented interface
 * @export
 * @class ProfileOverviewApi
 * @extends {BaseAPI}
 */
export class ProfileOverviewApi extends BaseAPI {
    /**
     *
     * @summary Get profile-overview via POST method. We agreed to never use the \"GET\" method on HTTP even if we semantically want just to retrieve data based on a given identifier. This is technically still be a POST method containing the CompanyId/UserId with a nested meId property in the message body
     * @param {number} [userProfileImageSize] A positive integer which describes the maximum edge length of the returned picture. The UPP will scale the picture to fit this size
     * @param {CompanyFSPBatchRequest} [companyFSPBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileOverviewApi
     */
    getProfileOverview(userProfileImageSize, companyFSPBatchRequest, options) {
        return ProfileOverviewApiFp(this.configuration).getProfileOverview(userProfileImageSize, companyFSPBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ProfilesApi - axios parameter creator
 * @export
 */
export const ProfilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get profiles via POST method.
         * @param {ProfilesFSPBatchRequest} [profilesFSPBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfiles: (profilesFSPBatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/profiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(profilesFSPBatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ProfilesApi - functional programming interface
 * @export
 */
export const ProfilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ProfilesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get profiles via POST method.
         * @param {ProfilesFSPBatchRequest} [profilesFSPBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfiles(profilesFSPBatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getProfiles(profilesFSPBatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ProfilesApi - factory interface
 * @export
 */
export const ProfilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ProfilesApiFp(configuration);
    return {
        /**
         *
         * @summary Get profiles via POST method.
         * @param {ProfilesFSPBatchRequest} [profilesFSPBatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfiles(profilesFSPBatchRequest, options) {
            return localVarFp.getProfiles(profilesFSPBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ProfilesApi - object-oriented interface
 * @export
 * @class ProfilesApi
 * @extends {BaseAPI}
 */
export class ProfilesApi extends BaseAPI {
    /**
     *
     * @summary Get profiles via POST method.
     * @param {ProfilesFSPBatchRequest} [profilesFSPBatchRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    getProfiles(profilesFSPBatchRequest, options) {
        return ProfilesApiFp(this.configuration).getProfiles(profilesFSPBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map